module.exports = __webpack_public_path__ + "static/media/Tennis Ace.ee75ae1b.jpg";